import React, { useState } from 'react'
import { Tabs, TabPanel } from '@paypalcorp/pp-react'
import { removeGAParam } from '../../pp-react-wrappers'

export default function UITabs({ children, ...rest }: any) {
  const { id } = rest

  const fptiData = typeof window !== `undefined` && window.fpti
  // @ts-ignore
  const gaData = typeof window !== `undefined` && window.ga
  const [selection, setSelection] = useState(0)
  const [tabs] = useState(
    children.map((child: any) => {
      return {
        label: child.props.label,
        id: child.props.label,
        panelId: child.props.label,
      }
    }),
  )
  const changeTabs = (e: any) => {
    const tabId = e.target.id
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: `tab-${id}-${e.target.id}`,
          component: 'devdiscoverynodeweb',
          space_key: 'SKEXJE',
          page_name: fptiData && fptiData.page.replace(/:/g, '_'),
          event_name:
            fptiData &&
            `${fptiData.page.replace(/:/g, '_')}_${tabId}_tab_pressed`,
          pu: removeGAParam(window.location.href),
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'tab',
        eventAction: 'click',
        eventLabel: `tab-${id}-${e.target.id}`,
      })
    }
    tabs.forEach((tab: any, index: number) => {
      if (tab.id === tabId) {
        setSelection(index)
      }
    })
  }

  return (
    <Tabs
      name="TabsGroup1"
      selectedTabIdx={selection}
      tabs={tabs}
      onClick={changeTabs}
      className="archetype-ui-tabs"
    >
      {children.map((child: any) => {
        return (
          <TabPanel
            id={child.props.label}
            tabId={child.props.label}
            key={child.props.label}
            className="archetype-ui-tab-panel"
          >
            {child.props.children}
          </TabPanel>
        )
      })}
    </Tabs>
  )
}
